var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61875 11.1875C4.10625 11.1875 3.675 11.0125 3.325 10.6625C2.975 10.3125 2.8 9.88125 2.8 9.36875C2.8 8.85625 2.975 8.425 3.325 8.075C3.675 7.725 4.10625 7.55 4.61875 7.55C5.13125 7.55 5.5625 7.725 5.9125 8.075C6.2625 8.425 6.4375 8.85625 6.4375 9.36875C6.4375 9.88125 6.2625 10.3125 5.9125 10.6625C5.5625 11.0125 5.13125 11.1875 4.61875 11.1875ZM1.375 15.5C1.075 15.5 0.8125 15.3875 0.5875 15.1625C0.3625 14.9375 0.25 14.675 0.25 14.375V2.75C0.25 2.45 0.3625 2.1875 0.5875 1.9625C0.8125 1.7375 1.075 1.625 1.375 1.625H2.59375V1.1C2.59375 0.925 2.65 0.78125 2.7625 0.66875C2.875 0.55625 3.01875 0.5 3.19375 0.5C3.36875 0.5 3.51562 0.55625 3.63437 0.66875C3.75312 0.78125 3.8125 0.925 3.8125 1.1V1.625H10.1875V1.1C10.1875 0.925 10.2438 0.78125 10.3563 0.66875C10.4688 0.55625 10.6125 0.5 10.7875 0.5C10.9625 0.5 11.1094 0.55625 11.2281 0.66875C11.3469 0.78125 11.4062 0.925 11.4062 1.1V1.625H12.625C12.925 1.625 13.1875 1.7375 13.4125 1.9625C13.6375 2.1875 13.75 2.45 13.75 2.75V14.375C13.75 14.675 13.6375 14.9375 13.4125 15.1625C13.1875 15.3875 12.925 15.5 12.625 15.5H1.375ZM1.375 14.375H12.625V6.3125H1.375V14.375ZM1.375 5.1875H12.625V2.75H1.375V5.1875Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.d6f4e5e1df6d448a97d571928dbf15bd.svg";
export { ForwardRef as ReactComponent };